import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { publicEditProfileStatusTypes, briefStatusOptions, briefStatusButtonNames, briefStatusColors, ShareableItemType, StatusType, allStatusTypes, ShareableItemTypes } from 'globals/store/share.data';
import { colorsByPublicEditProfile } from 'src/app/store/performers.era';
import { JoiEvent } from 'src/app/store/events.era';
import { ShareableFormat, ShareCodeComponent } from './share-code.component';
import { Wrapper } from 'src/app/components/wrapper.component';
import { compactDate, str2Date } from 'globals/helpers/helpers';
import { generateEmailLink } from '../../helpers/helpers';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { TitleToggleComponent } from 'src/app/components/wrappers/title-toggle-wrapper.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'binary-share-toggle',
    template: `
<title-toggle-wrapper
  *ngIf="{ off: type === 'profile' ? (status && status === profileStatusTypes.Off) : status !== 'On' } as vars"
  [title]="title"
  [hideBottom]="!alwaysOnMessage && (hideBottom || vars.off)"
  [toggleOn]="!vars.off"
  (toggle)="toggle.emit($event)"
  >
    <div *ngIf="!!alwaysOnMessage" [innerHTML]="helpers.strWithBreak(alwaysOnMessage)"></div>
    <ng-container *ngIf="!alwaysOnMessage || !vars.off">
    {{ instructions }}
    <div class="grey-hint" *ngIf="!!shareCode">
      {{ hint }}
    </div>
    <loader *ngIf="generatingCode" icon="button_wheel_grey"></loader>

    <share-code *ngIf="!!shareCode"
      [title]="shareTitle"
      [shareableFormat]="shareableFormat"
      [shareType]="shareType"
      [shareCode]="shareCode"
      [hideJson]="true"
      [disabled]="type === 'profile' ? (status !== allStatusTypes.Active && status !== allStatusTypes.Submitted) : !event.can_access"
      [statusOptions]="type === 'profile' ? profileOptions : briefStatus"
      [colorsByStatus]="type === 'profile' ? colorsByProfile : briefStatusColors"
      [namesByStatus]="type === 'profile' ? null : briefStatusButtonNames"
      [selectedStatus]="type === 'brief' ? null : status || null"
      [emailGenerator]="emailGenerator.bind(this)"
      (changeStatus)="changeStatus.emit($event)"
    ></share-code>
  </ng-container>
  <ng-content></ng-content>
</title-toggle-wrapper>
    `,
    styleUrls: ['./binary-share-toggle.scss'],
    standalone: true,
    imports: [ShareCodeComponent, CommonModule, LoaderComponent, TitleToggleComponent],
})
export class BinaryShareToggle extends Wrapper<BinaryShareToggle> implements OnDestroy {

  @Input() type: 'profile' | 'brief'
  @Input() shareType: ShareableItemType
  @Input() shareCode: string
  @Input() instructions: string
  @Input() hint: string
  @Input() title: string
  @Input() hideBottom = false
  @Input() shareTitle: string
  @Input() alwaysOnMessage: string
  @Input() generatingCode = false
  @Input() status?: StatusType
  @Input() shareableFormat:ShareableFormat = 'linksBelow'

  @Input() contactName: string
  @Input() contactEmail: string
  

  @Output() toggle: EventEmitter<boolean> = new EventEmitter()
  @Output() changeStatus: EventEmitter<string> = new EventEmitter()
  
  event: JoiEvent
  allStatusTypes = allStatusTypes
  profileStatusTypes = publicEditProfileStatusTypes
  colorsByProfile: any = colorsByPublicEditProfile
  profileOptions: StatusType[] = Object.values(publicEditProfileStatusTypes).filter(option=>option!==publicEditProfileStatusTypes.Off)

  briefStatus = briefStatusOptions
  briefStatusButtonNames = briefStatusButtonNames
  briefStatusColors = briefStatusColors

  constructor() {
    super()
    this.subProp(this.store.select('events','event'), 'event')
  }

  emailGenerator(publishCode: string) {
    const date = this.event.first_date
    const dateText = date ? `, ${compactDate(str2Date(date))}` : ''
    const title = this.event.title || 'untitled event'
    const subject = `${this.shareType === 'cues' ?  'Run of show' : 'Information required'} for ${title}${dateText}`
    const bodyMain = this.shareType === 'cues' ? 'Hi there,\n\nBelow is a link to run of show:' : this.shareType === ShareableItemTypes.notes ? 'Hi there,\n\nBelow is a link to facilitator notes:' : 
      this.type === 'brief' ? `Hi ${this.contactName},\n\nPlease see below a link to your brief for ${title}.\n\nPlease review the information in the brief and complete the actions requested.\n\nPlease note: The brief will automatically update if details change.` :
      this.shareType === ShareableItemTypes.entityAsset ? 'Hi there,\n\nBelow is a link to an asset form. Can you please complete the details and submit.' : 
      'Hi there,\n\nBelow is a link to your profile. Please open the link and complete your profile information then submit. Once submitted this information will appear in the program for the event.'
    const body = `${bodyMain}\n\n${publishCode}\n\nThanks`
    return generateEmailLink(subject, body, this.contactEmail || '')
  }

}
